import classNames from 'classnames';
import React, { memo } from 'react';
import styled from 'styled-components';
import { EMPTY_OBJ } from '../../constants';
import { COLOR, SIZE, fieldBorderRadius } from '../../styles';
import { type CardProps } from './Card.types';

const Card: React.FC<CardProps> = memo(
  ({
    children,
    className,
    dataTestId = 'card',
    id,
    style = EMPTY_OBJ,
    type = 'padded',
    colorMode = 'light',
  }) => {
    const cardClass = classNames('card', className, type, [colorMode]);
    return (
      <StyledCardSection className={cardClass} id={id} data-testid={dataTestId} style={style}>
        {children}
      </StyledCardSection>
    );
  },
);

// Styled Components
export const StyledCardSection = styled.section`
  background: ${COLOR['white']};
  border-radius: ${fieldBorderRadius};
  box-shadow: 0 2px 3px 2px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  display: block;
  outline: none;
  position: relative;
  width: 100%;

  &.dark {
    background: ${COLOR['dark-gray-dark']};
    color: ${COLOR['white']};
  }

  &.flat {
    box-shadow: none;
    padding: ${SIZE['16']};
  }

  &.padded {
    padding: ${SIZE['16']};
  }

  &.section {
    margin-top: ${SIZE['20']};
    padding: ${SIZE['20']};

    &:first-child {
      margin-top: 0;
    }
  }

  &.padded,
  &.section {
    header.card-header {
      padding: 0;
    }
  }

  &.open-padded,
  &.open.section {
    header.card-header {
      margin-bottom: ${SIZE['20']};
    }
  }
`;

// Display Name
Card.displayName = 'Card';

export default Card;
